import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreCountriesModule } from '@freelancer/datastore/collections';
import { FreightlancerRoutingModule } from './freightlancer-routing.module';

/**
 * This module is to route users from `/freightlancer/<page>` to the correct
 * module that is related to <page>. So for a user navigating to
 * `/freightlancer/about`, the FreightlancerPageRoutingModule will then load
 * FreightlancerAboutPageModule.
 */
@NgModule({
  imports: [CommonModule, DatastoreCountriesModule, FreightlancerRoutingModule],
})
export class FreightlancerModule {}
